
(function () {
  "use strict";

  if (window.__salepifyPopupByTriggerProduct) return;
  window.__salepifyPopupByTriggerProduct = true;

  var LOG_PREFIX = "[Custom][PopupByTrigger]";

  // 1. Hàm kiểm tra sản phẩm hiện tại có khớp trigger của Rule không
  function isRuleMatchCurrentProduct(rule, app) {
    try {
      if (!rule) return false;

      var data = window.tlFreeGiftData;
      if (!data || data.template !== "product" || !data.currentProduct) {
        return false;
      }

      // Ưu tiên dùng hàm check có sẵn của embedWidget nếu có
      try {
        if (app && app.embedWidget && typeof app.embedWidget.isApplicableToProduct === "function") {
          return app.embedWidget.isApplicableToProduct(rule);
        }
      } catch (errWidget) {
        // Fallback tự check nếu embedWidget gọi lỗi
      }

      var applyTo = rule.apply_to_product;
      if (applyTo === "all") return true;

      var currentProduct = data.currentProduct;
      var listParents = Array.isArray(rule.listParents) ? rule.listParents : [];
      var parentIds = listParents.map(function (p) {
        return String((p && p.shopify_id) || "").replace(/^gid:\/\/shopify\/[^/]+\//, "");
      });

      // Kiểm tra theo Collection (Chó / Mèo)
      if (applyTo === "collection") {
        var prodCollections = (currentProduct.collections || []).map(String);
        return parentIds.some(function (colId) {
          return prodCollections.indexOf(colId) !== -1;
        });
      }

      // Kiểm tra theo Product cụ thể
      if (applyTo === "product") {
        return parentIds.indexOf(String(currentProduct.id)) !== -1;
      }

      // Kiểm tra theo Variant
      if (applyTo === "variant") {
        var prodVariants = (currentProduct.variants || []).map(String);
        return parentIds.some(function (vId) {
          return prodVariants.indexOf(vId) !== -1;
        });
      }

      return true;
    } catch (err) {
      console.warn(LOG_PREFIX, "Error checking product match:", err);
      return false;
    }
  }

  // 2. Hook vào showPopupOffer của App
  function patch(app) {
    try {
      if (!app || app.__popupByTriggerPatched) return;
      app.__popupByTriggerPatched = true;

      var originalShowPopupOffer = app.showPopupOffer;
      if (typeof originalShowPopupOffer !== "function") return;

      app.showPopupOffer = function (eligibleOtherRules) {
        try {
          // Chỉ lọc khi đang ở product page
          if (window.tlFreeGiftData && window.tlFreeGiftData.template === "product") {
            if (Array.isArray(eligibleOtherRules)) {
              eligibleOtherRules = eligibleOtherRules.filter(function (item) {
                return item && item.rule && isRuleMatchCurrentProduct(item.rule, app);
              });
            }
          }
          return originalShowPopupOffer.call(this, eligibleOtherRules);
        } catch (errFilter) {
          // Lỗi phát sinh trong lúc lọc -> chạy ngay hàm gốc để không bao giờ treo popup
          console.error(LOG_PREFIX, "Filter error, fallback to original:", errFilter);
          return originalShowPopupOffer.apply(this, arguments);
        }
      };
    } catch (errPatch) {
      console.error(LOG_PREFIX, "Patch error:", errPatch);
    }
  }

  // 3. Khởi tạo & Bắt instance an toàn
  try {
    if (window.tlFreeGiftOffer) {
      patch(window.tlFreeGiftOffer);
      return;
    }

    var instance = window.tlFreeGiftOffer;
    Object.defineProperty(window, "tlFreeGiftOffer", {
      configurable: true,
      enumerable: true,
      get: function () {
        return instance;
      },
      set: function (val) {
        instance = val;
        try {
          patch(val);
        } catch (e) {
          console.error(LOG_PREFIX, "Setter patch error:", e);
        }
      },
    });
  } catch (errDefine) {
    // Fallback: nếu defineProperty bị chặn bởi script khác, dùng Polling ngắn hạn
    var pollCount = 0;
    var timer = setInterval(function () {
      pollCount++;
      if (window.tlFreeGiftOffer) {
        clearInterval(timer);
        patch(window.tlFreeGiftOffer);
      } else if (pollCount > 100) { // dừng sau ~10s
        clearInterval(timer);
      }
    }, 100);
  }
})();
